// extracted by mini-css-extract-plugin
export var quillEditor = "_ij-1";
export var variable = "_ij-0";